(function () {
  let initializedSwipers = [];

  const productSlider = () => {
    const productSliders = Array.from(
      document.querySelectorAll(".products-slider")
    );
    if (productSliders.length === 0) return;

    productSliders.forEach((slider) => {
      if (slider.classList.contains("slider_started")) return;
      // En mobile solo se arma el slider donde está activado; el resto queda en grid
      if (window.innerWidth < 768 && !allowsMobileSlider(slider)) return;

      slider.classList.add("slider_started");

      const sectionId = slider.dataset.id;
      const perRow = slider.dataset.perRow;
      const mobile = slider.dataset.mobile;
      const speed = slider.dataset.speed * 1000;
      const delay = slider.dataset.delay * 1000;
      const autoplay = toBoolean(slider.dataset.autoplay);
      const stopAutoplay = toBoolean(slider.dataset.stopAutoplay);
      const showArrows = toBoolean(slider.dataset.showArrows);

      let autoplayParm = {};
      let arrowsParm = {};

      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
          },
        };
      }

      if (showArrows) {
        arrowsParm = {
          navigation: {
            nextEl: `#${sectionId} .swiper-button-next`,
            prevEl: `#${sectionId} .swiper-button-prev`,
          },
          pagination: {
            el: `#${sectionId} .swiper-pagination`,
            clickable: true,
          },
        };
      }

      let swiperParms = {
        speed: speed,
        keyboard: true,
        slidesPerView: mobile,
        breakpoints: {
          576: {
            slidesPerView: perRow >= 2 ? 2 : 1,
          },
          750: {
            slidesPerView: perRow >= 3 ? 3 : perRow,
          },
          990: {
            slidesPerView: perRow >= 4 ? 4 : perRow,
          },
          1150: {
            slidesPerView: perRow,
          },
        },
        mousewheel: {
          forceToAxis: true,
        },
        ...arrowsParm,
        ...autoplayParm,
      };

      const swiper = new Swiper(`#${sectionId} .swiper`, swiperParms);
      initializedSwipers.push({ swiper, slider });
    });
  };

  // Popular products (con "Slider en mobile" activo) y recomendaciones del PDP
  // se mantienen como slider en mobile
  const allowsMobileSlider = (slider) =>
    slider.closest(".popular-products--mobile-slider, product-recommendations") !== null;

  const destroyGridSwipers = () => {
    initializedSwipers = initializedSwipers.filter(({ swiper, slider }) => {
      if (allowsMobileSlider(slider)) return true;
      if (swiper && swiper.destroy) {
        swiper.destroy(true, true);
      }
      slider.classList.remove("slider_started");
      return false;
    });
  };

  const adjustButtonPosition = (height) => {
    document
      .querySelectorAll(`.products-slider .swiper-button`)
      .forEach((button) => {
        button.style.top = height / 2 + 20 + "px";
      });
  };

  const changePosition = () => {
    if (window.innerWidth < 1150) return;

    const image = document.querySelector(`.products-slider .media img`);
    if (image) {
      if (image.tagName === "IMG") {
        if (image.complete) {
          adjustButtonPosition(image.offsetHeight);
        } else {
          image.addEventListener("load", function () {
            adjustButtonPosition(this.offsetHeight);
          });
        }
      } else if (image.tagName === "svg") {
        const height = image.getBoundingClientRect().height;
        adjustButtonPosition(height);
      }
    }
  };

  const toBoolean = (string) => {
    return string === "true";
  };

  const updateMobileGridClass = () => {
    const productSliders = document.querySelectorAll(".products-slider");
    productSliders.forEach((slider) => {
      if (window.innerWidth < 768 && !allowsMobileSlider(slider)) {
        slider.classList.add("product-list--2-mobile-grid");
      } else {
        slider.classList.remove("product-list--2-mobile-grid");
      }
    });
  };

  // Init product recommendations
  if (document.querySelector("product-recommendations") !== null) {
    const initslider = setInterval(() => {
      const swiperContainer = document
        .querySelector("product-recommendations")
        .querySelector(".swiper");

      if (swiperContainer !== null) {
        if (swiperContainer.classList.contains("swiper-initialized")) {
          clearInterval(initslider);
        }
        productSlider();
      }
    }, 100);

    // global.js vuelve a pintar las recomendaciones al cargarlas; cuando cambia
    // el contenido se arma de nuevo el slider
    new MutationObserver(() => productSlider()).observe(
      document.querySelector("product-recommendations"),
      { childList: true }
    );
  }

  // DOM ready
  document.addEventListener("DOMContentLoaded", function () {
    productSlider();
    updateMobileGridClass();
    changePosition();

    document.addEventListener("shopify:section:load", function () {
      productSlider();
      updateMobileGridClass();
      changePosition();
    });
  });

  // Resize
  let resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      updateMobileGridClass();
      changePosition();
      if (window.innerWidth < 768) {
        destroyGridSwipers();
      }
      productSlider();
    }, 200);
  });
})();
